import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {GridView} from "@mnjsplatform/components/lib/common/GridView/GridView";
import PopupWrapper from "../../Common/PopupWrapper";
import ModalWrapper from "@mnjsplatform/components/lib/common/modalWrapper";
import {popupArDetailsTypes} from "./ARGridContextMenu";
import Tabs from "@mnjsplatform/components/lib/common/TabControls/Tabs";
import {ComplexParam} from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import {ARFormLabel} from "./ARFormLabel";

const Details = ({dataItem, rowKey, access, accessField, children, readOnly = false} ) => {
    const dispatch = useDispatch();
    const hasAccess = access[accessField];
    useEffect(async () => {
        if (hasAccess) {
            await dispatch(dataItem.execute(rowKey));
        }
    }, []);

    if (!hasAccess){
        return null;
    }

    return (
        <>
            <GridView dataItem={dataItem} dispatch={dispatch} readOnly={readOnly}/>
            {children}
        </>
    );
}

const ARDetailsHistVac = ({title, onClose, rowKey, orgStructId, access, pageProps}) => {
    const dataItem = useSelector(({annualRemunerationReducer}) => annualRemunerationReducer.SalaryChangeData_ListForBossPO_HistVac);
    return (
        <Popup title={title} onClose={onClose}>
            {`${i18next.t("TabNum_Label")} ${orgStructId}: ${pageProps.Label_HistSalChForm}`}
            <Details rowKey={rowKey} dataItem={dataItem} access={access} accessField={"CanShow_HistVacForm"}/>
        </Popup>
    )
}

const ARDetailsHistSalCh = ({title, onClose, rowKey, access}) => {
    const dataItem_ListForBossPO_Log = useSelector(({annualRemunerationReducer}) => annualRemunerationReducer.SalaryChangeData_ListForBossPO_Log);
    const dataItem_ListForLog = useSelector(({annualRemunerationReducer}) => annualRemunerationReducer.SalaryChangeFixPers_ListForLog);
    const tabs = [{key: "tab_rises", value: i18next.t("ARDetails_1")}, {key: "tab_fixes", value: i18next.t("ARDetails_2")}];
    const [state, setState] = useState({activeTabValue: tabs[0].key});

    const tabSelectedHandler = (tab) => {
        setState({activeTabValue: tab.key});
    }
    return <Popup title={title} onClose={onClose}>
        <Tabs tabs={tabs} valueField={"key"} textField={"value"} activeTabValue={state.activeTabValue} onSelected={tabSelectedHandler} />
        {state.activeTabValue === "tab_rises" &&
            <Details rowKey={rowKey} dataItem={dataItem_ListForBossPO_Log} access={access} accessField={"CanShow_HistSalChForm"} readOnly={true} />
        }
        {state.activeTabValue === "tab_fixes" &&
            <Details rowKey={rowKey} dataItem={dataItem_ListForLog} access={access} accessField={"CanShow_HistFixForm"} />
        }
    </Popup>
}

const ARDetailsHistFix = ({title, onClose, rowKey, access, pageProps}) => {
    const dispatch = useDispatch();
    const [dataItem, dataItemYBMF, dataItemYBMFParams] = useSelector(({annualRemunerationReducer}) =>
      [
        annualRemunerationReducer.SalaryChangeData_ListForBossPO_YB_2020,
        annualRemunerationReducer.SalaryChangeData_ListForBossPO_YBMF_2020,
        annualRemunerationReducer.SalaryChangeData_ListForBossPO_YBMF_2020Params,
      ]
    );

    useEffect(async () => {
        await dispatch(dataItemYBMF.execute(rowKey));
    }, []);

    const renderParams = (h) => {
        const fieldName = 'DescPerCent';
        return (
        <>
            <label className={"field-title m-0"}>
                {h.lbl(fieldName)}
            </label>
            <div className={""}>
                {h.ed(fieldName)}
            </div>
        </>
        );
    }

    const saveHandler = async () => {
        await dispatch(dataItemYBMF.applyParams(dataItemYBMFParams, true));
        // if (!dataItemYBMF.isError) {
        //     onClose();
        // }
    }

    const renderFooter = () => {
        return (
            <div className={"d-flex flex-row border-top"}>
                <div className={"p-2 mt-auto"}>
                    <div style={{width: '300px', fontSize: '12px'}}>
                        {pageProps.Legend_YBDetailForm.split('\\n').map((value, index) => <React.Fragment key={new Date().getTime() + index}>{index > 0 ? <br/> : null}{value}</React.Fragment>)}
                    </div>
                </div>
                <div className={"p-2 mt-auto"}>
                    <div style={{width: '250px', lineHeight: '15px'}}>
                        <ARFormLabel text={pageProps.Label_YBDetailForm} />
                    </div>
                </div>
                <div className={"p-2 mt-auto"}>
                    <ComplexParam dataItem={dataItemYBMF} showSearchBar={false} showApplyButton={false} renderParams={renderParams} />
                </div>
                <div className={"pt-2 pb-2 mt-auto"}>
                    {!!access.CanChange_YBMF &&
                        <button className="btn btn-regular" onClick={saveHandler}>
                            {i18next.t('Save')}
                        </button>
                    }
                </div>
                <div className={"pt-2 pb-2 mt-auto"}>
                    <button className="btn btn-regular" onClick={onClose}>
                        {i18next.t('Close')}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <Popup title={title} onClose={onClose} renderButtons={renderFooter}>
            <Details rowKey={rowKey} dataItem={dataItem} access={access} accessField={"CanShow_YBDetailForm"} />
        </Popup>
    );
}

const CloseControl = <button type="button" className="close" data-dismiss="modal" style={{color: "#fff", opacity: 1}}><>&times;</></button>

const Popup = ({title, onClose, renderButtons = null, children}) => {

    return (
        <ModalWrapper>
            <PopupWrapper title={title} onClose={onClose} popupVisible={true} headerStyle={{background: "#002147"}} renderButtons={renderButtons} closeControl={CloseControl}>
                {children}
            </PopupWrapper>
        </ModalWrapper>
    );
}

const ARDetails = ({popupType = "", rowKey, name, orgStructId, access, pageProps, onClose})=>{
    if (!popupType) {
        return null;
    }

    const titleText = popupType === popupArDetailsTypes.histVac && i18next.t("ARDetails_3") ||
            popupType === popupArDetailsTypes.histSalCh && i18next.t("ARDetails_4") ||
        popupType === popupArDetailsTypes.histSalCh && i18next.t("ARDetails_5");
    const title = (<div><h2 className={"m-0"} style={{color: "#fff"}}>{name}</h2><h3 className={"m-0"} style={{color: "#fff"}}>{titleText}</h3></div>)

    return (
        <>
            {popupType == popupArDetailsTypes.histVac &&
                <ARDetailsHistVac title={title} onClose={onClose} rowKey={rowKey} orgStructId={orgStructId} access={access} pageProps={pageProps}  />
            }
            {popupType == popupArDetailsTypes.histSalCh &&
                <ARDetailsHistSalCh title={title} onClose={onClose} rowKey={rowKey} access={access} />
            }
            {popupType == popupArDetailsTypes.histFix &&
                <ARDetailsHistFix title={title} onClose={onClose} rowKey={rowKey} access={access} pageProps={pageProps}  />
            }
        </>
    );
}

ARDetails.default = {
    popupType: null,
    name: null,
    rowKey: null
}

ARDetails.propTypes = {
    popupType: PropTypes.string,
    name: PropTypes.string,
    orgStructId: PropTypes.string,
    rowKey: PropTypes.object,
    access: PropTypes.object,
    pageProps: PropTypes.object,
    onClose: PropTypes.func,
};

export { ARDetails }